export default __webpack_public_path__ + "static/media/recibir.f37421e2.svg";